import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { newFormatPrice } from '../../../../../services/utilityFunctions';
import CustomCheckbox from '../../../../../commonComponents/forms/inputs/CustomCheckbox';
import ProductVariationsProp from '../../../../shop/propTypes/productVariationsProp';
import translate from '../../../../../commonComponents/translate';

function ProductItem(props) {
  const { t, variation, onClick } = props;
  const {
    name: variationName,
    parentProduct,
    icon,
    _id,
    userPrice,
    userPromotionPrice,
    lowStockWarning,
    stockQuantity,
    isPack,
    images,
    packVariations,
    packType,
  } = variation || {};
  const { name: parentName } = parentProduct || {};
  let price = userPromotionPrice
    ? newFormatPrice(
        userPromotionPrice?.price || 0,
        true,
        userPromotionPrice?.code,
      )
    : newFormatPrice(userPrice?.price || 0, true, userPrice?.code);

  if (userPrice?.price === 0 || userPromotionPrice?.price === 0) {
    price = t('free');
  }

  const stockForItem = useMemo(() => {
    let stockToCheck = stockQuantity;
    if (isPack) {
      const stockArray = packVariations?.map(packVariation => {
        const { quantity, variation: pVariation } = packVariation || {};
        const { stockQuantity: pVStockQuantity } = pVariation || {};
        const stock =
          typeof pVStockQuantity === 'number' ? pVStockQuantity : Infinity;
        return quantity * stock;
      });
      stockToCheck = Math.min(...(stockArray || []));
    }
    return stockToCheck;
  }, [variation]);

  const stockMessage = useMemo(() => {
    let message = '';
    if (lowStockWarning && stockForItem && lowStockWarning >= stockForItem) {
      message = t('product.stock.warning', stockForItem);
    }
    if (stockForItem === 0) {
      message = t('product.no.stock');
    }
    return message;
  }, [variation]);
  const image = !isPack ? icon?.thumb : images[0].thumb;

  const title =
    packType === 'advanced' ? t('shop.advancedPack') : t('shop.pack');
  return (
    <div className="product-item-wrapper" key={variation.name}>
      <CustomCheckbox
        id={_id}
        onClick={() => onClick(variation)}
        disabled={stockForItem === 0}
      />
      <img src={image} alt={variationName} />
      <div className="name-wrapper">
        {isPack && <span className="badge-pack">{title}</span>}
        <h5 className="parentProductName">{parentName}</h5>
        <p className="variationName">{variationName}</p>
        {stockMessage?.length > 0 ? (
          <p className="stock">{stockMessage}</p>
        ) : null}
      </div>
      <div className="form-wrapper" />
      <div className="price-wrapper">
        <p>{price}</p>
      </div>
    </div>
  );
}

ProductItem.propTypes = {
  t: PropTypes.func.isRequired,
  variation: PropTypes.shape(ProductVariationsProp.propType).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default translate(ProductItem);
